import { IDocumentClient } from "@multiweb/clients/documents";
import { IDocumentMetadata, IDocumentVersionInfo } from "@multiweb/types/contracts";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { SerializeFuncs } from "OW.Remoting/Remoting/Serializers";
import { RequestContext } from "../../../RequestContext";
import { BaseClient } from "../BaseClient";

interface IDocumentMetadataDTO {
    OriginalHash: string;
    HashCode: string;
    HashAlg: string;

    [attribute: string]: string;
}

export class DocumentClient extends BaseClient implements IDocumentClient {
    public getDocumentName(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<string> {
        return this._communicationManager.callGETRequest("DocumentName", ASServices.dms, { instanceID: instanceID, attributeName: attributeName }, undefined, requestContext);
    }

    public getDocumentHashCode(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<string> {
        return this._communicationManager.callGETRequest("DocumentHashCode", ASServices.dms, { instanceID: instanceID, attributeName: attributeName }, undefined, requestContext);
    }

    public getDocumentMetadata(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<IDocumentMetadata> {
        return this._communicationManager.callGETRequest("DocumentMetadata", ASServices.dms, { instanceID: instanceID, attributeName: attributeName }, undefined, requestContext)
            .then(transformMetadata);
    }

    public getDocumentVersions(instanceID: string, attributeName: string, requestContext?: RequestContext): Promise<IDocumentVersionInfo[]> {
        return this._communicationManager.callGETRequest("DocumentVersions", ASServices.dms, { instanceID: instanceID, attributeName: attributeName }, undefined, requestContext).then((data: IDocumentVersionInfo[]) => {
            for (const v of data) {
                if (v.CreateTime) v.CreateTime = SerializeFuncs.deserializeDateTime(v.CreateTime.toString()); // ze služby přišlo jako JSON, který je potřeba správně přetypovat
            }
            return data;
        });
    }
}

const transformMetadata = (metadata: IDocumentMetadataDTO): IDocumentMetadata => ({
    hash: metadata.HashCode,
    hashAlgorithm: metadata.HashAlg,
    originalHash: metadata.OriginalHash,
    ...metadata,
});
